import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "./components"
import "@/plugins/mixins";
import VueGates from 'vue-gates'
import VCalendar from 'v-calendar';

import vueCustomElement from 'vue-custom-element'
import RockiotContainer from './components/rockiot/components/rockiot.container.vue'
import RockiotAnimatedNumber from './components/rockiot/components/rockiot.animated.number.vue'
import './assets/rockiot.ui.css'
import './assets/rockiot.chart.css'
import './components/rockiot/plugins/rockiot.radial'

import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
// import ElementUI's styles
import 'element-ui/lib/theme-chalk/index.css';
// import this package's styles
import 'element-tiptap/lib/index.css';


Vue.config.productionTip = false;


Vue.use(VueGates);

Vue.use(VCalendar, {componentPrefix: 'vc'});

Vue.use(vueCustomElement)
Vue.use(ElementUI);
// use this package's plugin
Vue.use(ElementTiptapPlugin, {
  lang: "es", // see i18n
  spellcheck: true, // can be overwritten by editor prop
 });
Vue.customElement('rockiot-ui', RockiotContainer)
Vue.component('rockiot-animated-number',RockiotAnimatedNumber)



new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
